import { render, staticRenderFns } from "./KnListWithActions.vue?vue&type=template&id=539fbefd"
import script from "./KnListWithActions.vue?vue&type=script&lang=js"
export * from "./KnListWithActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports